import {
    Separator,
    Text
} from "@fluentui/react";
import { RootState } from "app/store";
import SimpleCard, { ECalloutTypes, ECardIcon, ICardProperties } from "components/controls/SimpleCard";
import { appStyles } from "global/Application";
import * as IXrmTypes from "model/CRM";
import { IBenefitList } from "model/CRM.type";
import * as FAM from "model/FlexibleAttributeModel";
import React from "react";
import { useHistory } from "react-router";
import BenefitCallout from "./Controls/BenefitCallout";

export enum EBenefitCardFunction {
    display,
    addToPlan,
    addToGroupConfiguration,
}
export interface IProps extends ICardProperties {
    benefit: FAM.IBenefit;
    benefitCollection?: IBenefitList;
    contextPlans?: FAM.IPlan[];
    currentPlan?: FAM.IPlan | null;
    currentPlanBenefits?: FAM.IBenefit[] | null;
    currentPlanCategories?: IXrmTypes.bcbs_config_category[] | null;
    state: RootState
    mode: EBenefitCardFunction
    icon?: ECardIcon;
}

const redStyle = { root: { color: 'red' } };


/**
 * 
 * Note: this component has two display modes:
 * - display for showing within collection
 * - addition to allow adding to collections, which applies some of the rules and validations by disabling
 * @param props 
 * @returns 
 */
const BenefitCard: React.FC<IProps> = (props) => {

    const history = useHistory();

    const onRenderAdd = () => {
        const {
            benefit,
            onClick,
            benefitCollection,
            currentPlan,
            currentPlanBenefits,
            currentPlanCategories,
        } = props;

        const sameBenefit = currentPlanBenefits?.some(q => q.id === benefit.id)
        const sameCategory = currentPlanCategories?.some(q => q.bcbs_config_categoryid === benefit.bcbs_config_categoryid);
        const similar = benefitCollection?.some(t => t.selected && t.item.bcbs_config_categoryid === benefit.bcbs_config_categoryid && t.item.id !== benefit.id);

        let fundingTypeMissMatch = props.currentPlan?.fundingType?.value !== benefit.fundingType?.value;
        if (!benefit.bcbs_isfundingtypeenabled)
            fundingTypeMissMatch = false;

        const grandFatheredMissMatch = benefit.bcbs_isgrandfatherenabled && currentPlan?.grandFathered?.value !== benefit.grandFathered?.value;
        const disabled = sameBenefit || sameCategory || similar || grandFatheredMissMatch || fundingTypeMissMatch;
        const important = disabled;
        const selected = benefitCollection?.some(t => t.selected && benefit.id === t.item.id);

        const onCallout = () => {
            return (
                <>
                    <BenefitCallout
                        contextPlans={props.contextPlans}
                        benefit={props.benefit}
                        mode={props.mode}
                    />
                    {important &&
                        <>
                            <Separator />
                            <Text block variant="xLarge" className={appStyles.title}>
                                Notifications
                            </Text>
                            {sameBenefit &&
                                <>
                                    <Text block variant="small" styles={redStyle}>This benefit has already been selected.</Text>
                                    <Separator />
                                </>
                            }
                            {sameCategory &&
                                <>
                                    <Text block variant="small" styles={redStyle}>A benefit with same category has already been associated with current context.</Text>
                                    <Separator />
                                </>
                            }
                            {similar &&
                                <>
                                    <Text block variant="small" styles={redStyle}>A benefit with same category has already been selected.</Text>
                                    <Separator />
                                </>
                            }
                            {fundingTypeMissMatch &&
                                <>
                                    <Text block variant="small" styles={redStyle}>Benefit's funding ({benefit.fundingType?.name}) does not match plans funding ({currentPlan?.fundingType?.name}).</Text>
                                    <Separator />
                                </>
                            }
                            {grandFatheredMissMatch &&
                                <>
                                    <Text block variant="small" styles={redStyle}>Benefit's GF/NGF type ({benefit.grandFathered?.name}) does not match plan's GF/NGF type ({currentPlan?.grandFathered?.name}).</Text>
                                    <Separator />
                                </>
                            }
                        </>
                    }
                    {/* 
                    <Text block variant="xLarge" className={appStyles.title}>
                        Benefit Information
                    </Text>
                    <Text block variant="small" >
                        Individual deductible $0.00<br />
                        Family deductible $0.00<br />
                        Out of pocket max $0.00<br />
                    </Text> */}
                </>
            );
        }

        return (
            <SimpleCard
                {...props}
                key={benefit.id}
                description={benefit.name}
                selected={selected}
                header={benefit.bcbs_name}
                disabled={disabled}
                icons={props.icon}
                onCallout={onCallout}
                callout={important ? ECalloutTypes.notification : ECalloutTypes.comment}
                onClick={onClick}
                overflowItems={props.overflowItems}
            // deactivated={benefit.deactivated}
            />
        );
    }

    const onRenderDisplay = () => {
        const { benefit, benefitCollection, onClick } = props;
        const selected = benefitCollection?.some(t => t.selected && benefit.id === t.item.id);

        const onCallout = () => {
            return <BenefitCallout
                contextPlans={props.contextPlans}
                benefit={props.benefit}
                mode={props.mode}
            />
        }

        return (
            <SimpleCard
                {...props}
                key={benefit.id}
                description={benefit.name}
                selected={selected}
                header={benefit.bcbs_name}
                icons={props.icon}
                onCallout={onCallout}
                onClick={onClick}
                overflowItems={props.overflowItems}
            // deactivated={benefit.deactivated}
            />
        )
    }

    if (props.mode === EBenefitCardFunction.addToPlan)
        return onRenderAdd();

    return onRenderDisplay();

}

export default BenefitCard;